import AbstractView from '@/core/view/abstractView';
import template from './personComparisonView.tpl';
import styles from './style.module.scss';
import LogUtil from '@/core/utils/logUtil';
import PersonComparisonModel from './model/personComparisonModel';
import AppStateModel from '../../model/appStateModel';
import StepController from './steps/stepController';
import JSONLoader from '@/core/loader/jsonLoader';
import Results from './steps/results/results';
import Selection from './steps/selection/selection';


export default class PersonComparisonView extends AbstractView {

    private steps: any;
    private stepContainer: HTMLElement | undefined;

    constructor(id:string, data:any, params:any) {
        super(id, data, params);

        this._template = template({data: this._data, styles: styles});
    }

    preload(completeCallback) {
        let jsonFile = this._data.model['lifespan'];

        function loadDataSuccessHandler(result) {
            AppStateModel.birthdayMap = result[0]['birthdayMap'];
            completeCallback();
        }

        function loadDataErrorHandler(error) {
            LogUtil.error('Loading JSON Error. Couldn´t load ', jsonFile, error);
        }

        JSONLoader.loadAll([jsonFile]).then(loadDataSuccessHandler.bind(this), loadDataErrorHandler.bind(this));
    }


    init() {

        this.steps = {
            // keys need to match with "next_button" data-target.
            selection: new Selection(this._data),
            results: new Results(this._data)
        };

        StepController.setTimeline();
        StepController.setSteps(this.steps);
        StepController.setTarget(this.stepContainer);
        StepController.setData(this._data);

        if (AppStateModel.canJumpToStepOnce()) {
            StepController.nextStep('results' );
        } else {
            StepController.nextStep('selection' ); // ----------- TODO edit here to start at a different step by default.
        }
    }

    render() {
        super.render();

        if (this._element) {
            this.stepContainer = this._element.querySelectorAll('.step')[0] as HTMLElement;
        }
    }

    destroy() {
        /*
         EventDispatcher.removeMultipleEventListeners(this.backButton, InterfaceUtil.listener.down, startButtonDownHandler);
         */
    }
}
